import { useEffect, useState } from 'react'
import useLocalState from '@hooks/useLocalState'
import useScrollTriggerContext from '@contexts/scrollTriggerContext'
import FollowingFeed from '@components/feeds/FollowingFeed'
import ForYouFeed from '@components/feeds/ForYouFeed'
import NearbyFeed from '@components/feeds/NearbyFeed'
import HomeTopNav from '@components/feeds/HomeTopNav'
import SwipeableViews from 'react-swipeable-views'
import ScreenContainer from './ScreenContainer'

const Home = () => {
  const [selectedItem, setSelectedItem] = useLocalState('selected-feed-tab', 2)
  // Local Scroll Trigger
  const [scrollTarget, setScrollTarget] = useState(undefined)
  // // Global Scroll Trigger
  const { useScrollTriggerEffect } = useScrollTriggerContext()
  useScrollTriggerEffect(scrollTarget)

  useEffect(() => {
    setScrollTarget(false)
  }, [selectedItem])

  return (
    <>
      <HomeTopNav
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
      />
      <ScreenContainer>
        <SwipeableViews
          onChangeIndex={(i) => setSelectedItem(i)}
          index={selectedItem}
          enableMouseEvents
          axis='x'>
          <ForYouFeed
            setScrollTarget={setScrollTarget}
            currentTab={selectedItem}
          />
          <FollowingFeed
            setScrollTarget={setScrollTarget}
            currentTab={selectedItem}
          />
          <NearbyFeed
            setScrollTarget={setScrollTarget}
            currentTab={selectedItem}
          />
        </SwipeableViews>
      </ScreenContainer>
    </>
  )
}

export default Home
